<script>
import moment from 'moment';
import { mapState } from 'pinia';

import { useUserStore } from '../../../../store/useUserStore.js';
import { SectionPostTypes } from '../../constants';

export default {
  name: 'CpSocialFeedNewsPost',
  data() {
    return {
      showLikesModal: false,
      comments_count: this.news.comments_count,
      type: SectionPostTypes.NEWS,
      showLobbyDialog: false,
    };
  },
  directives: {
    margin: require('../../directives/margins').margin,
    marginBottom: require('../../directives/margins').marginBottom,
    marginTop: require('../../directives/margins').marginTop,
    marginRight: require('../../directives/margins').marginRight,
  },
  components: {
    CpBaseSvgIcon: require('../../base-svg-icon').default,
    CpSocialShareDialog: require('../../dialogs/social-share').default,
    LikeActionButton: require('../actions/like-action-button').default,
    CpDialog: require('../../dialog').default,
    CpLikesProfiles: require('../../likes/likes-profiles').default,
    CpButtonLink: require('../../button-link').default,
    CommentActionButton: require('../actions/comment-action-button').default,
    CpCommentsPost: require('../../comments/box-comments').default,
    CpGrid: require('../../grid').default,
    CpGridItem: require('../../grid-item').default,
    CpDialogAuthForm: require('../../auth-form/dialog-auth-form').default,
    CpCardHeaderReactions: require('../../components/CardHeaderReactions').default,
    getEmbedUrl: require('../../mixins/utils.js').default,
    CpShowInteractionsCount: require('../../components/ShowInteractionsCount').default,
    CpTruncateText: require('../../components/TruncateText').default,
    CpShowImageInCard: require('../../components/ShowImageInCard').default,
    LobbyActionButton: require('../actions/lobby-action-button').default,
    CpLobbyFlowDialog: require('../../dialogs/LobbyFlowDialog').default,
  },
  props: {
    news: { type: Object, default: {} },
    explore: Boolean,
    forShare: Boolean, //Is shared in explore
    pinned: { type: Boolean, default: false },
  },
  computed: {
    ...mapState(useUserStore, ['userProfileData']),
    isAddressCompleted() {
      return this.userProfileData?.address_state && this.userProfileData?.address_zip;
    },
    datePostedFormatted() {
      return moment.utc(this.news.rss_published_at).local().format('MMM. Do hh:mm a');
    },
    authUser() {
      return this.$root.authUser;
    },
    videoEmbedUrl() {
      return this.getEmbedUrl(this.news.video_url);
    },
  },
  methods: {
    imageAltUrl(event) {
      event.target.src = 'https://res.cloudinary.com/crowdpac/image/upload/v1596929923/social-feed/news-default-bg.png';
    },
    handleLikesModal() {
      this.showLikesModal = !this.showLikesModal;
    },
    handleCountLikes(value) {
      value ? (this.news.likes_count = this.news.likes_count + 1) : (this.news.likes_count = this.news.likes_count - 1);
    },
    setCommentsCount(action) {
      action == 'remove' ? this.comments_count-- : this.comments_count++;
    },
    profile(slug) {
      return '/profile/' + slug;
    },
    handleLobbyDialog() {
      this.showLobbyDialog = !this.showLobbyDialog;
    },
  },
};
</script>

<template>
  <div class="social-feed-post-wrapper">
    <!-- TO DO: uncomment this when we implement the new feed logic -->
    <!-- <div v-if="explore && news.last_activity && !forShare && !pinned" style="display: flex">
      <CpCardHeaderReactions :post="news.last_activity" />
    </div>
    <hr v-if="explore && news.last_activity && !forShare && !pinned" class="search-results__tick_action" />
    -->

    <h3 class="subheadline1 primary-color text-right" v-margin="0">NEWS</h3>
    <a :href="news.permalink" class="headline black-color underline-decoration" v-margin-bottom="0.5">{{ news.title }}</a>
    <div v-if="news.video_url">
      <div class="video-embed-container">
        <iframe v-if="videoEmbedUrl !== null" class="video-embed" :src="videoEmbedUrl" frameborder="0" allowfullscreen="allowfullscreen" />
      </div>
    </div>
    <CpShowImageInCard v-if="!!news.image" :image="news.image" :link="news.permalink" v-margin-bottom="1" />
    <CpTruncateText :content="news.content" :enableTruncate="!!news.image || !!news.video_url" />
    <div class="news-footer">
      <p class="body1 primary-color" v-margin-right="0.5">Source: {{ news.rss_publisher_name }}</p>
      <p class="body1 primary-color">{{ datePostedFormatted }}</p>
    </div>

    <div v-if="!forShare" style="margin-top: 10px !important">
      <CpShowInteractionsCount :type="type" :id="news.id" :likesCount="news.likes_count" :commentsCount="comments_count" :handleLikesModal="handleLikesModal" />
    </div>

    <cp-dialog v-if="showLikesModal && !forShare">
      <cp-likes-profiles :count-likes="news.likes_count" :id="parseInt(news.id)" :type="'news'" @close="handleLikesModal"></cp-likes-profiles>
    </cp-dialog>

    <div v-if="!forShare" class="social-feed-post-actions">
      <div class="post-action-button like">
        <like-action-button type="news" :id="news.id" :liked="news.liked" :onSuccess="handleCountLikes" />
      </div>
      <div class="post-action-button comment">
        <comment-action-button :type="type" :id="news.id" />
      </div>
      <div class="post-action-button share">
        <cp-social-share-dialog
          class="feed"
          :allow-share-feed="true"
          share-category="News"
          :explore="explore"
          :type="'news'"
          :post="news"
          share-button-class="button--noborder"
          :url="news.permalink"
          title="News found via CrowdBlue - Social Network For Politics"
          description="Wanted to share this news I found on CrowdBlue, the Social Network for Politics."
          :quote="news.title"
          hashtags="crowdBlue,politics,political crowdfunding"
          twitter-user="crowdblue"
        ></cp-social-share-dialog>
      </div>
      <div class="post-action-button like">
        <LobbyActionButton :handleLobbyDialog="handleLobbyDialog" title="Contact My Reps" />
      </div>
    </div>

    <cp-comments-post v-show="!forShare" :id="news.id" :type="type" :setCount="setCommentsCount"> </cp-comments-post>

    <CpLobbyFlowDialog
      v-if="showLobbyDialog"
      :showDialog="showLobbyDialog"
      type="none"
      customSubject="Concern over government spending"
      :newsArticle="news"
      :callback="handleLobbyDialog"
      shareMessageInComments
      :originalPostType="type"
      :originalPostId="news.id"
      @close="handleLobbyDialog"
    />
  </div>
</template>

<style scoped>
.underline-decoration {
  text-decoration: underline;
}
.news-footer {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-top: 10px;
}
.more-button {
  cursor: pointer;
}
div.social-feed-post-actions {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  padding: 7px 0px;
}
.profile-img {
  border-radius: 50%;
  width: 60px;
  height: 60px;
  object-fit: contain;
  margin-right: 12px;
}
div.social-feed-post-profile-wrapper {
  display: flex;
  flex-direction: row;
  margin-bottom: 1em;
}
div.social-feed-post-profile-wrapper .details-wrapper {
  display: flex;
  flex-direction: column;
}

div.social-feed-post-profile-wrapper .profile-name {
  font-size: 1.3em;
  font-weight: 600;
  padding-bottom: 5px;
  padding-right: 5px;
  margin: 1px;
}

div.social-feed-post-profile-wrapper .post-time {
  color: #666;
  text-decoration: none;
  font-size: 0.9em;
  font-weight: 400;
}

img.social-feed-post-img {
  max-width: 100%;
  max-height: 100%;
  min-width: 100%;
}
span.social-feed-default-img {
  display: flex;
  align-items: center;
  justify-content: center;
}
a.social-feed-post-link {
  display: block;
  padding-top: 10px;
  font-size: 1.1em;
}

div.social-feed-post-wrapper {
  width: 100%;
  padding: 1.5em;
  padding-top: 1em;
  border-bottom: 2px solid var(--neutral3);
  margin-bottom: 2.5em;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: auto;
}
div.social-feed-wrapper {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
}
.social-feed-post-wrapper > * {
  width: 100%;
}

.mini-recipient__subtitle {
  margin-top: 0px;
}

div.social-feed-box-wrapper.mobile img.social-feed-post-img {
  min-height: 45vh;
  object-fit: cover;
}
.social-feed-default-img {
  background: #ffe3da;
  color: var(--highlight);
}
div.social-feed-box-wrapper.mobile div.social-feed-post-wrapper {
  padding: 0.7em;
}
div.social-feed-post-img-placeholder {
  min-height: 400px;
  background: rgb(233, 94, 54);
  background: linear-gradient(180deg, rgba(233, 94, 54, 1) 65%, rgba(254, 130, 94, 1) 100%);
  display: flex;
  align-items: center;
  justify-content: center;
}
header.social-feed-title-header {
  text-align: center;
  margin: 30px 0px;
}
div.social-feed-post-description {
  padding-top: 10px;
}
.search-results__tick_action {
  color: #cacaca;
  width: 50px;
  margin-right: auto;
}
.video-embed-container {
  display: flex;
  justify-content: center;
}
.video-embed {
  width: 100%;
  aspect-ratio: 16 / 9;
}

@media screen and (max-width: 500px) {
  .news-footer {
    flex-direction: column;
    align-items: flex-start;
  }
}
</style>
